export default __webpack_public_path__ + "static/media/54.4b562ef3.jpg";